export const questions = [
  {
    id: 1,
    question: "Would you lie to your friends?",
    answer: "Would {user} lie to his friends?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "All The Time",
        url: "AllTheTime.png"
      },
      {
        name: "Depends",
        url: "Depends.png"
      },
      {
        name: "Never",
        url: "Never.png"
      },
      {
        name: "Only If Necessary",
        url: "OnlyIfNecessary.png"
      }
    ]
  },
  {
    id: 2,
    question: "Do your trust your friends with your life ?",
    answer: "Does {user} trust his friends with his life ?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "Always",
        url: "Always_.png"
      },
      {
        name: "Never",
        url: "Never_.png"
      },
      {
        name: "No",
        url: "No_.png"
      },
      {
        name: "Yes",
        url: "Yes_.png"
      }
    ]
  },
  {
    id: 3,
    question: "What Kind of food you enjoy with your Friends?",
    answer: "What Kind of food does {user} enjoy with his Friends?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "Chinese Food",
        url: "Chinese Food.jpg"
      },
      {
        name: "Fast Food",
        url: "Fast Food.jpg"
      },
      {
        name: "South Indian",
        url: "South Indian.jpg"
      },
      {
        name: "Street Food",
        url: "Street Food.jpg"
      }
    ]
  },
  {
    id: 4,
    question: "How often do you go out with your Best Friends?",
    answer: "How often does {user} go out with his Best Friends?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "Every Weekend",
        url: "Every Weekend.jpg"
      },
      {
        name: "EVERYDAY",
        url: "EVERYDAY.png"
      },
      {
        name: "In A Month",
        url: "In A Month.png"
      },
      {
        name: "Once In A Week",
        url: "Once In A Week.png"
      }
    ]
  },
  {
    id: 5,
    question: "All of your friends forgot your birthday! How do you feel?",
    answer: "All of {user} friends forgot his birthday! How does {user} feel?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "",
        url: "67348435_2390711784327557_6041881068246663168_n.png"
      },
      {
        name: "",
        url: "67596204_351852365486333_2271790438316769280_n.png"
      },
      {
        name: "",
        url: "67789039_401635957125796_2724468257464516608_n.png"
      },
      {
        name: "",
        url: "67829544_2461832574092027_4611640075162222592_n.png"
      }
    ]
  },
  {
    id: 6,
    question: "What's you think the most important thing about your friends?",
    answer: "What's you think the most important thing about {user}'s friends?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "",
        url: "67343746_3457534990939271_4014181515511463936_n.png"
      },
      {
        name: "",
        url: "67406018_633651657147379_3307322845977116672_n.png"
      },
      {
        name: "",
        url: "67482148_387168848605373_8923475752138047488_n.png"
      },
      {
        name: "",
        url: "67665196_497768857649597_8235033451397382144_n.png"
      }
    ]
  },
  {
    id: 7,
    question:
      "If one of your friends is about to lose his/her eyesight, would you help pay for the operation?",
    answer:
      "If one of {user} friends is about to lose his/her eyesight, would he help pay for the operation??",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "Doubt It",
        url: "67308353_474685513334300_5027451200711163904_n.png"
      },
      {
        name: "Depends On Cost",
        url: "67404650_2409363199343516_7377834687231688704_n.png"
      },
      {
        name: "Of Course",
        url: "67899516_647264089113201_2407199938137030656_n.png"
      },
      {
        name: "No Way",
        url: "68278177_504960526919525_8575750415260319744_n.png"
      }
    ]
  },
  {
    id: 8,
    question: "Would you die for your best friend?",
    answer: "Would {user} die for his best friend?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "Depends",
        url: "67219923_382675349272512_96492444668919808_n.png"
      },
      {
        name: "Yes",
        url: "67358839_1520395314757277_3660440174992556032_n.png"
      },
      {
        name: "No",
        url: "67403653_332362267710187_7379004043617632256_n.png"
      },
      {
        name: "Never",
        url: "67567196_2309221219192404_8802929429027225600_n.png"
      }
    ]
  },
  {
    id: 9,
    question: "Have you ever dated any of opposite sex friends?",
    answer: "Have {user} ever dated any of opposite sex friends?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "Yes",
        url: "67358839_1520395314757277_3660440174992556032_n.png"
      },
      {
        name: "No",
        url: "67403653_332362267710187_7379004043617632256_n.png"
      },
      {
        name: "Can't Remember",
        url: "67621626_511050982970924_83148793029066752_n.png"
      }
    ]
  },
  {
    id: 10,
    question:
      "If one of your friend really wanted to date you, but you didn't like him/her that way, What would you say?",
    answer:
      "If one of {user} friend really wanted to date him, but {user} didn't like him/her that way, What would he say?",
    hide: 0,
    featured: 1,
    images: [
      {
        name: "Yes",
        url: "67358839_1520395314757277_3660440174992556032_n.png"
      },
      {
        name: "No",
        url: "67403653_332362267710187_7379004043617632256_n.png"
      },
      {
        name: "May be",
        url: "67362821_753104311792350_8036294113336754176_n.png"
      },
      {
        name: "I have to think",
        url: "67926720_496637017572695_8937058916924129280_n.png"
      }
    ]
  },
  {
    id: 11,
    question: "If all your friends died, how would you feel?",
    answer: "If all {user} friends died, how would he feel?",
    hide: 0,
    featured: 0,
    images: [
      {
        name: "Angry",
        url: "Angry_53.jpg"
      },
      {
        name: "Depressed_53",
        url: "Depressed_53.jpg"
      },
      {
        name: "Don't Care",
        url: "Dont Care_53.jpg"
      },
      {
        name: "Horrified",
        url: "Horrified_53.jpg"
      },
      {
        name: "Sad",
        url: "Sad_53.jpg"
      }
    ]
  },
  {
    id: 12,
    question: "What do you most look for in a friend?",
    answer: "What does {user} look for in a friend?",
    hide: 0,
    featured: 0,
    images: [
      {
        name: "Love",
        url: "Love.jpg"
      },
      {
        name: "Money",
        url: "Money.jpg"
      },
      {
        name: "Popularity",
        url: "Popularity.jpg"
      },
      {
        name: "Trust",
        url: "Trust.jpg"
      }
    ]
  },
  {
    id: 13,
    question: "If a friend needed $500, would you lend him/her the money?",
    answer: "If a friend needed $500, would {user} lend him/her the money?",
    hide: 0,
    featured: 0,
    images: [
      {
        name: "Yes",
        url: "67358839_1520395314757277_3660440174992556032_n.png"
      },
      {
        name: "No",
        url: "67403653_332362267710187_7379004043617632256_n.png"
      },
      {
        name: "I don't have $500",
        url: "67589614_1370423053098485_4384990708172324864_n.png"
      },
      {
        name: "It depends on friend",
        url: "67753429_364021850952713_5457202527382536192_n.png"
      }
    ]
  },
  {
    id: 14,
    question: "How much do you trust your friends?",
    answer: "How much do {user} trust his friends?",
    hide: 0,
    featured: 0,
    images: [
      {
        name: "0 - 20%",
        url: "67500258_2923936951165627_4792303884443844608_n.png"
      },
      {
        name: "21% to 45%",
        url: "67721444_417948072263877_2193069971318243328_n.png"
      },
      {
        name: "46% to 70%",
        url: "67537473_498842750870115_5609151332079370240_n.png"
      },
      {
        name: "71% to 94%",
        url: "67573344_2422683914462023_3834064283767930880_n.png"
      },
      {
        name: "95% - 100%",
        url: "67404327_400767330788388_5425032152888639488_n.png"
      }
    ]
  },
  {
    id: 15,
    question: "How much do you think your friends trust you?",
    answer: "How much do you think {user}'s friends trust him?",
    hide: 0,
    featured: 0,
    images: [
      {
        name: "0 - 20%",
        url: "67500258_2923936951165627_4792303884443844608_n.png"
      },
      {
        name: "21% to 45%",
        url: "67721444_417948072263877_2193069971318243328_n.png"
      },
      {
        name: "46% to 70%",
        url: "67537473_498842750870115_5609151332079370240_n.png"
      },
      {
        name: "71% to 94%",
        url: "67573344_2422683914462023_3834064283767930880_n.png"
      },
      {
        name: "95% - 100%",
        url: "67404327_400767330788388_5425032152888639488_n.png"
      }
    ]
  }
];
